/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request body for POST chat endpoint.
 */
export interface ChatRequest {
  message: string;
}
